import { PRIORITY_COLOR } from "@founderdeck/core";
import type { Project, Task } from "./api";
import { todayKey } from "./date";

export function projectMap(projects: Project[] | undefined): Map<string, Project> {
  return new Map((projects ?? []).map((p) => [p.id, p]));
}

export function priColor(pri: number): string {
  return PRIORITY_COLOR[pri] ?? PRIORITY_COLOR[4]!;
}

export function isHardLate(t: Task): boolean {
  return Boolean(t.deadline && t.status !== "done" && t.deadline < todayKey());
}

/** Open task scheduled for a day before today = stale (roll candidate). */
export function isStale(t: Task): boolean {
  return Boolean(t.doDate && t.status !== "done" && t.doDate < todayKey());
}

export function activeMits(tasks: Task[]): Task[] {
  return tasks.filter((t) => t.mit && t.status !== "done").slice(0, 3);
}

/** The (up to 3) Top-3 tasks starred for a specific day. */
export function mitsForDate(tasks: Task[], date: string): Task[] {
  return tasks.filter((t) => t.mitDate === date && t.status !== "done").slice(0, 3);
}
